var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconelogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 389,
    viewBox: "0 0 389 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconelogo",
    clipPath: "url(#clip0_12_45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.5668 0H0V389H48.5668V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M291.732 0H243.166V389H291.732V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M388.999 0H340.433V173.576H388.999V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M145.834 0H97.2676V173.576H145.834V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M145.834 222.144H97.2676V389.001H145.834V222.144Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 389,
    height: 389,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconelogo);
export default __webpack_public_path__ + "static/media/iconelogo.6a98c6a534546733fca73a31e4370bc9.svg";
export { ForwardRef as ReactComponent };